import { render, staticRenderFns } from "./SlickGrid.vue?vue&type=template&id=5a486bf2&"
import script from "./SlickGrid.vue?vue&type=script&lang=js&"
export * from "./SlickGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports